var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLayer1Icon = function SvgLayer1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#layer1-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 26.25a.75.75 0 0 1-.75-.75v-9.75c0-.199.08-.39.22-.53l12-12A.75.75 0 0 1 15 3h6a.75.75 0 1 1 0 1.5h-5.69L3.75 16.06v9.44a.75.75 0 0 1-.75.75M33.53 42.22 24 32.69v-5.015a3.75 3.75 0 1 0-1.5 0V33c0 .199.08.39.22.53l9.75 9.75a.75.75 0 0 0 1.06-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6.75a3.744 3.744 0 0 0-3.125 5.815L7.72 19.72a.75.75 0 0 0-.22.53V30H3a.75.75 0 1 0 0 1.5h5.25a.75.75 0 0 0 .75-.75V20.56l6.935-6.935A3.75 3.75 0 1 0 18 6.75M43.5 21.75a.75.75 0 0 0-.75.75v9.44l-2.435 2.435a3.761 3.761 0 1 0 1.06 1.06l2.655-2.655a.75.75 0 0 0 .22-.53V22.5a.75.75 0 0 0-.75-.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 30a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 .75-.75h5.25a.75.75 0 1 1 0 1.5H39v11.25a.75.75 0 0 1-.75.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 6c-.735 0-1.453.217-2.065.625L32.03 3.22A.75.75 0 0 0 31.5 3h-6a.75.75 0 0 0-.75.75v6c0 .199.08.39.22.53l7.28 7.28v9.88l-3.53 3.53a.75.75 0 1 0 1.06 1.06l3.75-3.75a.75.75 0 0 0 .22-.53v-10.5a.75.75 0 0 0-.22-.53l-7.28-7.28V4.5h4.94l3.185 3.185A3.75 3.75 0 1 0 37.5 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.53 43.72 14.25 30.44v-6.88L19.81 18h5.69a.75.75 0 1 0 0-1.5h-6a.75.75 0 0 0-.53.22l-6 6a.75.75 0 0 0-.22.53v7.5c0 .199.08.39.22.53L25.19 43.5h-9.88l-3.19-3.175a3.775 3.775 0 1 0-1.066 1.056l3.421 3.4A.75.75 0 0 0 15 45h12a.75.75 0 0 0 .53-1.28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "layer1-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgLayer1Icon;